import React from 'react';
import { Box, CssBaseline, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import QueueIcon from '@mui/icons-material/Queue';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import HistoryIcon from '@mui/icons-material/History';

const drawerWidth = 240;

const navItems = [
  { label: 'Queue', to: '/', icon: <QueueIcon />, match: '' },
  { label: 'Check In', to: '/check-in', icon: <AddCircleOutlineIcon />, match: 'check-in' },
  { divider: true },
  { label: 'Reports', to: '/reports', icon: <BarChartIcon />, match: 'reports' },
  { divider: true },
  { label: 'Configuration', to: '/configuration', icon: <SettingsIcon />, match: 'configuration' },
  { label: 'Users', to: '/users', icon: <PeopleIcon />, match: 'users' },
  { label: 'Audit Log', to: '/audit', icon: <HistoryIcon />, match: 'audit' },
];

const SideNavBar = ({ handleDrawerToggle, mobileOpen, access }) => {
  const location = useLocation();
  const active = location.pathname.toLowerCase().substring(1).split('/')[0];

  const isAdmin = access?.lobbyRole === 'admin' || access?.admin;

  const drawer = (
    <List>
      {navItems.map((item, i) => {
        if (item.divider) return <Divider key={i} />;
        if ((item.match === 'configuration' || item.match === 'users' || item.match === 'audit') && !isAdmin)
          return null;
        return (
          <ListItem key={item.to} disablePadding>
            <ListItemButton component={Link} to={item.to} selected={active === item.match}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );

  const drawerSx = { '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, position: 'static' } };

  return (
    <>
      <CssBaseline />
      <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}>
        <Drawer variant="temporary" open={mobileOpen} onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{ display: { xs: 'block', sm: 'none' }, ...drawerSx }}
        >
          {drawer}
        </Drawer>
        <Drawer variant="permanent" sx={{ display: { xs: 'none', sm: 'block' }, ...drawerSx }} open>
          {drawer}
        </Drawer>
      </Box>
    </>
  );
};

export default SideNavBar;
